<section
  class="flex flex-col items-center justify-center px-3 h-[80dvh] text-center gap-6"
>
  <img src="{{ urlImg + '404.png' }}" class="w-5/6 max-w-lg" />
  <div class="flex flex-col items-center justify-center gap-10 w-full">
    <div class="flex flex-col gap-2 items-center justify-center w-full">
      <p class="text-blue text-15-20 font-bold">
        {{ "404_description_1" | translate }}
      </p>
      <p class="text-blue text-15-20 font-bold">
        {{ "404_description_2" | translate }}
      </p>
    </div>
    <button
      class="w-full rounded-8 bg-red-2 leading-10 px-3 py-2 text-white text-15-20 font-bold sm:max-w-319"
      (click)="handleBackHome()"
    >
      {{ "404_button" | translate }}
    </button>
  </div>
</section>
